// FreeSearchFilter.js
import React from 'react';
import { useLanguage } from '../../LanguageContext';

const FreeSearchFilter = ({ freeSearch, onChangeFreeSearch, retrieveArtworks }) => {
  const { selectedLanguage } = useLanguage();
  const search = () => retrieveArtworks(1);
  return (

        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder={selectedLanguage === 'en' ? 'Free search' : 'Ricerca libera'}
            value={freeSearch}
            onChange={onChangeFreeSearch}
            onKeyDown={(e) => { if (e.key === 'Enter') search(); }}
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={search}
            >
              {selectedLanguage === 'it' ? 'Cerca' : 'Search'}
            </button>
          </div>
        </div>

  );
};

export default FreeSearchFilter;
